import { LoaderWithoutText } from "../../../../shared/LoaderWithoutText/LoaderWithoutText";
import { DeleteIcon } from "../../../../assets/svg/DeleteIcon";
import { downloadImage } from "../../../../utils/functions/downloadImage";
import { DownloadIcon } from "../../../../assets/svg/DownloadIcon";
import { useAppDispatch, useAppSelector } from "../../../../redux/store";
import { getIsShowInnerLoader } from "../../../../redux/reducers/app/appSelectors";
import styles from "./HistoryList.module.scss";
import { getUser } from "../../../../redux/reducers/user/userSelectors";
import { popUp } from "../../../../features/popUp/PopUp";
import {
  deleteHistoryItemThunk,
  getHistoryListThunk,
} from "../../../../redux/reducers/history/historyThunks";
import { getHistory } from "../../../../redux/reducers/history/historySelectors";
import { changeShowModal } from "../../../../redux/reducers/app/appReducer";
import PreviewIcon from "../../../../assets/svg/PreviewIcon";

export const HistoryList = () => {
  const dispatch = useAppDispatch();
  const history = useAppSelector(getHistory());
  const user = useAppSelector(getUser());
  const userID = user && user.id >= 0 && user.id;
  const { isShowHistoryLoader } = useAppSelector(getIsShowInnerLoader());

  const handleDeleteHistoryItem = async (configHash: string) => {
    if (!configHash) return;

    const historyData = await dispatch(
      deleteHistoryItemThunk(configHash)
    ).unwrap();

    if (historyData) {
      popUp({ type: "success", message: "History was deleted successfully" });
      await dispatch(getHistoryListThunk({ id: Number(userID) })).unwrap();
    }
  };

  const handlePreviewHistoryItem = (imageUrl: string) => {
    if (!imageUrl) return;

    dispatch(
      changeShowModal({
        nameModal: "fullScreenPreview",
        stateModal: true,
        otherParams: { img: imageUrl },
      })
    );
  };

  return (
    <>
      {isShowHistoryLoader ? (
        <LoaderWithoutText />
      ) : history && !history.length ? (
        <p>History is empty</p>
      ) : (
        <div className={styles.content}>
          {history.map(history => {
            const { imageUrl, configHash } = history;

            return (
              <div className={styles.contentItem} key={configHash}>
                <div
                  className={styles.img_wrapper}
                  onClick={() => handlePreviewHistoryItem(imageUrl)}
                >
                  <img src={imageUrl} alt="templateItemImg" />
                  <div className={styles.preview_overlay}>
                    <span>
                      <PreviewIcon />
                      Preview
                    </span>
                  </div>
                </div>
                <div className={styles.information}>
                  <div className={styles.name}>
                    {configHash ? configHash : "name"}
                  </div>
                </div>
                <div className={styles.action}>
                  <button
                    disabled={!imageUrl}
                    onClick={() => downloadImage(imageUrl)}
                  >
                    <DownloadIcon /> Download
                  </button>
                  <button onClick={() => handleDeleteHistoryItem(configHash)}>
                    <DeleteIcon /> Delete
                  </button>
                </div>
              </div>
            );
          })}
        </div>
      )}
    </>
  );
};
